export default __webpack_public_path__ + "static/media/calendar-line.03fa3f04.svg";